import { AdminCollectionEditor } from '../../_Shared/_UI/AdminCollectionEditor';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { ADMIN_DEFAULT_ORDER, ADMIN_FEATURED_FILTER, ADMIN_VISIBILITY_FILTER } from '../../_Shared/_Config/AdminCollectionFilters';
import { SALE_PROJECTS_ADMIN_API as API } from '../_MODULES/_API';
import { SaleOrdersPanel } from './SaleOrdersPanel';
import '../../_Shared/_UI/_Styles/PortfolioAdmin.css';

const SALE_PROJECT_FILTERS = [
    ADMIN_VISIBILITY_FILTER,
    ADMIN_FEATURED_FILTER,
    {
        key: 'currency_filter',
        field: 'currency',
        label: 'Moneda',
        type: 'select',
        placeholder: 'Todas',
    },
];

export const SaleProjectsViewMain = () => (
    <AdminViewLayout
        pageKey="sale-projects"
        title="Proyectos en venta"
        description="Publicá productos digitales listos para comprar, definí precio y alias, y gestioná los comprobantes que envían los clientes."
        isWide
    >
        <AdminCollectionEditor
            title="Catálogo de venta"
            description="Estos proyectos aparecen como una sección independiente del portfolio y no reemplazan tus proyectos profesionales."
            listEndpoint={API.LIST}
            saveEndpoint={API.SAVE}
            removeEndpoint={API.REMOVE}
            titleField="title"
            subtitleField="stack"
            imageField="image"
            searchFields={['title', 'slug', 'stack', 'short_description', 'description', 'payment_alias', 'payment_provider']}
            filters={SALE_PROJECT_FILTERS}
            orderOptions={ADMIN_DEFAULT_ORDER('title')}
            fields={[
                { name: 'image', label: 'Portada', type: 'image', span: 2 },
                { name: 'title', label: 'Título' },
                { name: 'slug', label: 'Slug (opcional)' },
                { name: 'stack', label: 'Tecnologías', span: 2 },
                { name: 'short_description', label: 'Descripción corta', type: 'textarea', rows: 2, span: 2 },
                { name: 'description', label: 'Descripción completa', type: 'textarea', rows: 4, span: 2 },
                { name: 'price', label: 'Precio', type: 'number' },
                { name: 'currency', label: 'Moneda (ARS, USD...)', defaultValue: 'ARS' },
                { name: 'payment_alias', label: 'Alias de pago', span: 2 },
                { name: 'payment_holder', label: 'Titular' },
                { name: 'payment_provider', label: 'Banco / billetera' },
                { name: 'delivery_text', label: 'Texto de entrega', type: 'textarea', rows: 2, span: 2 },
                { name: 'support_text', label: 'Texto de deploy / soporte', type: 'textarea', rows: 2, span: 2 },
                { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 },
                { name: 'featured', label: 'Recomendado', type: 'checkbox' },
                { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />

        <SaleOrdersPanel />
    </AdminViewLayout>
);
